import InvoiceORM from "@/store/orm-axios/models/Invoice";

export default {
  GET_BY_MEETING(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        InvoiceORM.api()
          .GET_BY_MEETING(meetingId)
          .then(res => {
            InvoiceORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
